import { FindingsContract } from '@terra/shared-contracts-findings';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'orchestrator';

export const findingsClient = createTerraOrpcClient({
  contract: FindingsContract,
  serviceName: SERVICE_NAME,
});
